module.exports = __webpack_public_path__ + "static/media/PhD_Application_Form1.3bc31e9f.pdf";